import React from "react";
import SideCompaniesSection from "../CompaniesSection";

const AboutSection = () => {
  return (
    <section
      id="AboutSection"
      className="flex flex-col items-center justify-between space-y-6 px-4 py-10 lg:flex-row lg:space-y-0"
    >
      <div className="flex w-11/12 lg:w-full flex-col items-center justify-center space-x-2">
        <div className="w-full 2xl:w-2/3 space-y-12 text-left">
          <div className="flex w-full flex-row items-start pb-0">
            <h1 className="text-3xl 2xl:text-4xl font-light leading-tight">
              How was my 6 years or more in the tech industry?
            </h1>
          </div>
          <div className="flex w-full flex-row items-center justify-between space-x-0 px-1">
            <div className="flex flex-row items-center justify-center">
              <div className="hidden w-[180px] rotate-90 border-t-[3px] border-dashed border-[#000] lg:flex"></div>
            </div>
            <div className="flex flex-col items-start justify-between space-y-3">
              <p className="text-sm font-normal leading-loose opacity-90">
                Fast-forward to today, I’ve had the privilege of working at a
                development agency, a start-up, a global corporate and a
                multiple large open source projects. My main focus these days is
                building accessible, inclusive, web or mobile products & digital
                experiences with a team of experts for a variety of worldwide
                clients.
              </p>
            </div>
          </div>
        </div>
        <SideCompaniesSection></SideCompaniesSection>
      </div>
    </section>
  );
};

export default AboutSection;
